import { useQuery } from "@apollo/client/react";
import queryCustomerSettings from 'graphql/queries/queryCustomerSettings'
import {
  CustomerSettings,
  CustomerSettings_customerSettings,
} from 'graphql/queries/types/CustomerSettings'

type CustomerSettingsResult =
  | ({ loading: true } & Partial<CustomerSettings_customerSettings>)
  | ({ loading: false } & Partial<CustomerSettings_customerSettings>)

export function useCustomerSettings(): CustomerSettingsResult {
  const { data, loading } = useQuery<CustomerSettings>(queryCustomerSettings)
  const customerSettings = data?.customerSettings
  if (loading) {
    return { loading }
  }
  return { ...customerSettings, loading: false }
}
